var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotAuth = function SvgNotAuth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 7.58887,
    y: 8.49023,
    width: 112.5,
    height: 112.5,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0342 99.4684H100.523V25.1206H10.0342V99.4684Z",
    fill: "#D6DAE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.295 44.178L80.3034 95.5556L17.3711 85.7926L25.3627 34.4143L88.295 44.178Z",
    fill: "#F4F5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0664 80.3924L35.4686 43.2185",
    stroke: "white",
    strokeWidth: 0.763359
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4258 81.3707L41.828 44.1968",
    stroke: "white",
    strokeWidth: 0.763359
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.035 60.3381C100.035 52.5041 93.6839 46.1533 85.8498 46.1533C78.0158 46.1533 71.665 52.5041 71.665 60.3381",
    stroke: "#18263C",
    strokeWidth: 1.52672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.9033,
    y: 60.3381,
    width: 49.8913,
    height: 49.8913,
    fill: "#FFC200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1807 25.6742H37.3288V13.4563H10.1807V25.6742Z",
    fill: "#B5BEC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8064 87.9117C90.3609 87.0865 92.2086 84.6888 92.2086 81.8597C92.2086 78.3479 89.3617 75.501 85.8499 75.501C82.3381 75.501 79.4912 78.3479 79.4912 81.8597C79.4912 84.6888 81.3389 87.0865 83.8934 87.9117V96.7485C83.8934 97.1701 84.2351 97.5118 84.6567 97.5118H87.0431C87.4647 97.5118 87.8064 97.1701 87.8064 96.7485V87.9117Z",
    fill: "#18263C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotAuth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_auth.6bdbf0c7.svg";
export { ForwardRef as ReactComponent };